module.exports = __webpack_public_path__ + "03_long_beige.1ef7a97c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/03_long_beige.png
// module id = EYAv
// module chunks = 0